module Meevo.Plugins.WaitList {
    export class StepsModal {
        static $inject = [
            '$scope',
            'appointmentBookModalService',
            "meevo.components.common.DataService",
            'waitService',
            "client",
            "meevo.plugins.appointmentBook.stepOverrideService"
        ];

        constructor(
            protected $scope,
            protected modal,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected waitService,
            private client,
            protected stepOverrideService
        ) {
            this.stepOverrideService.initialize(waitService, this.client).then(() => {
                $scope.steps = waitService.steps;
            });

            $scope.modal = modal;

            $scope.stepDurationDisabled = () => {
                if (!this.waitService.service) {
                    return true;
                }
                return this.waitService.service.doNotAllowStepTimingOverride;
            }

            $scope.closeModal = () => {
                this.modal.hideModal('close');
            }

            $scope.saveModal = () => {
                this.modal.hideModal().then(() => {
                    this.stepOverrideService.check(this.waitService, this.client);
                });
            }
        }
    }

    angular.module("meevo.plugins.waitList")
        .controller("meevo.plugins.waitList.StepsModalController", StepsModal);
}